<template>
	<div id="Dashboard">
		<MouseFlow />
		<NavBar />
		<div id="page-main" onclick="window.portal.nav.close()">
			<NotificationBanner />
			<CredentialClaim v-if="welcome_loaded && should_load_welcome" />
			<UserAccount v-if="user_loaded" />
			<Messages />
			<CredentialExchange v-if="user_loaded" />
			<Orders @update-installments="updateInstallments" v-if="user_loaded" />
			<OrderInstallments ref="OrderInstallments" v-if="user_loaded"/>
			<AdditionalInformation />
		</div>
	</div>
</template>

<script>
	import MouseFlow from './MouseFlow.vue';
	import NavBar from './NavBar.vue';
	import UserAccount from './UserAccount.vue';
	import Messages from './Messages.vue';
	import CredentialExchange from './CredentialExchange.vue';
	import Orders from './Orders.vue';
	import AdditionalInformation from './AdditionalInformation';
	import OrderInstallments from "@/components/OrderInstallments";
  import CredentialClaim from "@/components/CredentialClaim";
	import NotificationBanner from "./NotificationBanner.vue";

	export default {
		name: 'Dashboard',
	components: {
			MouseFlow,
			NavBar,
			UserAccount,
			Messages,
			CredentialExchange,
			Orders,
			AdditionalInformation,
			OrderInstallments,
      CredentialClaim,
			NotificationBanner,
		},
		data() {
			return {
				user: window.portal.user,
				welcome: window.portal.welcome,
				welcome_loaded: false,
				should_load_welcome: false,
			}
		},
		computed: {
			user_loaded: function () { return (this.user.id != null && this.user.id != '' && this.user.id.decode() > 0) ? true : false; },
		},
		mounted: function() {
			this.Load();
			this.checkSettings()
		},
		methods: {
      updateInstallments() {
        this.$refs.OrderInstallments.Load();
      },
			Load() {
				this.welcome.load = this.LoadWelcome;
				this.welcome.reload = this.ReloadWelcome;
			},
			LoadWelcome() {
				window.debug('welcome: load');
				this.welcome.loaded = this.welcome_loaded = true;
			},
			ReloadWelcome() {
				window.debug('welcome: reload');
				this.welcome.loaded = this.welcome_loaded = false;
				if (window.helpers.isFunction(window.portal.welcome._reload)) { window.portal.welcome._reload() }
				this.welcome.loaded = this.welcome_loaded = true;
			},
      checkSettings: function() {
        // Check and set settings - this is needed to use the settings from the API call in UserPortal.vue
        if (typeof(window.portal.ticket_claiming_enabled) !== 'undefined') {
          this.should_load_welcome = window.portal.ticket_claiming_enabled;
        } else {
          setTimeout(() => {
            this.checkSettings()
          }, 100);
        }
      },
		}
	}
</script>

<style>
	/* #### Main #### */
	#Dashboard { text-align: center; width: 100%; position: relative; z-index: 999; margin-bottom: 400px; }
	#page-main { display: block; position: relative; margin: 0px auto; text-align: left; width: 100%; /* max-width: var(--max-page-width); */ padding: var(--mainpage-padding) calc(calc(calc(100% - var(--max-page-width)) / 2) + var(--mainpage-padding)); box-sizing: border-box; background: var(--mainpage-background); color: var(--mainpage-text-color); }
	#page-main .box {
		--header-color: var(--box-header-color);
	}
	#page-main .box { display: block; margin-bottom: 20px; }
	@media only screen and (max-width: 650px) {
		#page-main { padding: 10px; }
	}
</style>
